export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=54026590&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/index.vue?vue&type=template&id=54026590&scoped=true
// module id = iEkT
// module chunks = 0